/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { memo } from 'react';
import Styles from '../css/ResetPasswordPage.module.css';
import SWLogo from '../assets/SWLogoWhBg.png';
import ResetPasswordForm from '../components/forms/ResetPasswordForm';
import { ResetPasswordProvider } from '../contexts/ResetPasswordContext';

const ResetPasswordPage = () => {
  return (
    <ResetPasswordProvider>
      <section className={Styles.page}>
        <img className={Styles.swLogo} src={SWLogo} alt='Sun West Mortgage Company Inc.' />
        <section className={Styles.wrapperSection}>
          <ResetPasswordForm />
        </section>
      </section>
    </ResetPasswordProvider>
  );
};

export default memo(ResetPasswordPage);
